import { ContinuationBar } from './ContinuationBar';

/**
 * Container para a barra de progresso da continuação falada
 * @param {Object} props
 * @param {string} props.continuation - Continuação da frase para exibição
 * @param {boolean} props.allPrefixedWordsCorrect - Se todas as palavras prefixadas estão corretas
 * @param {number} props.minWords - Número mínimo de palavras necessárias
 * @param {boolean} props.isMyTurn - Se é o turno do participante
 */
export const SpokenContinuationContainer = ({ continuation, allPrefixedWordsCorrect, minWords = 4, isMyTurn = true }) => {
  // Se não é meu turno, mostra apenas "..."
  if (!isMyTurn) {
    return (
      <span style={{
        fontSize: '36px',
        color: 'rgba(255, 255, 255, 0.5)',
        fontStyle: 'italic'
      }}>
        ...
      </span>
    );
  }

  // Se é meu turno, mostra a barra de progresso
  return (
    <ContinuationBar
      continuation={continuation}
      minWords={minWords}
      allPrefixedWordsCorrect={allPrefixedWordsCorrect}
    />
  );
};
